<h2 mat-dialog-title>
  💬 Responder comentario
</h2>

<mat-dialog-content>

  <!-- Comentario original -->
  <div class="comment-preview">

    <strong>
      {{ data.comment.username }}
    </strong>

    <p>
      {{ data.comment.message }}
    </p>

  </div>

  <!-- IA -->
  <div class="reply-ai-section">

    <button
      type="button"
      class="se-ai-btn"
      (click)="showAiPanel = !showAiPanel">

      ✨ {{ showAiPanel ? 'Ocultar IA' : 'Generar con IA' }}

    </button>

    <div *ngIf="showAiPanel" class="se-ai-panel">

      <textarea class="se-textarea" [(ngModel)]="aiPrompt" rows="2"placeholder="Describe la respuesta que deseas generar">
      </textarea>

      <div class="se-ai-controls">

        <select class="se-select" [(ngModel)]="aiTone">

          <option value="profesional">
            Profesional
          </option>

          <option value="casual">
            Casual
          </option>

          <option value="entusiasta">
            Entusiasta
          </option>

          <option value="informativo">
            Informativo
          </option>

        </select>

        <button type="button" class="se-btn se-btn--primary" [disabled]="aiGenerating || !aiPrompt.trim()" (click)="generateWithAi()">

          {{ aiGenerating ? 'Generando...' : 'Generar' }}

        </button>

      </div>

    </div>

  </div>

  <!-- Respuesta -->
  <div class="reply-field">

    <label class="reply-label">
      Tu respuesta
    </label>

    <textarea class="se-textarea" rows="5" [(ngModel)]="replyMessage" placeholder="Escribe tu respuesta aquí...">
    </textarea>

    <div class="reply-counter">
      {{ replyMessage?.length || 0 }} caracteres
    </div>

  </div>

</mat-dialog-content>

<mat-dialog-actions align="end" class="reply-actions">

  <button mat-stroked-button type="button" (click)="close()">

    <mat-icon class="me-1">
      close
    </mat-icon>

    Cancelar

  </button>

  <button mat-raised-button color="primary" type="button" [disabled]="sending || !replyMessage.trim()" (click)="send()">

    <mat-icon class="me-1">
      send
    </mat-icon>

    Responder

  </button>

</mat-dialog-actions>